angular
    .module('WizApp')
    .factory('ScrollerService', [
        '$q',
        function ($q) {
            return {
                to(selector, gutter = 20) {
                    return $q((resolve, reject) => {
                        const $target = $(selector);

                        if ($target.length <= 0) {
                            reject('no target');
                            return;
                        }

                        const secondaryTopBar = $('.bw-container');
                        const secondaryTopBarBottom = secondaryTopBar.outerHeight() || 0;

                        const $topbar = $('.topbar');
                        const topbarBottom = secondaryTopBarBottom + $topbar.outerHeight();

                        const targetTop = $target.offset().top;
                        const gutterHeight = gutter;
                        const top = targetTop - topbarBottom - gutterHeight;

                        $('html, body').animate({
                            scrollTop: top
                        }, 'slow', resolve);
                    });
                }
            };
        }
    ]);
